<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户贷款'}]"/>
    <div class="xzpadd10 bg-purple of">
        <data-table
          :table-data="tableData"
          :columns="columns"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :filters.sync="filters"
          :actions="actions"
        />
      </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "FinancingList",
        data(){
          return{
            transactionStatus: 'Pending Approval',
            tableData: {
              count: 0,
              data: []
            },
            dealerTypeOptions:[],
            page: 1,
            pageSize: 20,
            actions: [
              /*{
                label: '新增',
                class: 'el-icon-plus',
                clickHandler: ()=>{
                  this.$router.push({
                    path: 'add'
                  })
                }
              }*/
            ],
            filters: {
              labelWidth: '150px',
              form: {
                fi__transactionNo:'',
                fi__customerName:'',
                c__customerContactNo:'',
                d__dealerId:'',
                fi__transactionDate:[],
                fi__startDate:[],
                fi__endDate:[],
                fi__transactionStatus:'',
                fi__repaymentFormula:'',
                overdue:'',
              },
              columns: [
                {
                  label: '贷款编号',
                  component: 'el-input',
                  field: 'fi__transactionNo',

                },
                {
                  label: '客户姓名',
                  component: 'el-input',
                  field: 'fi__customerName',
                  span:12

                },
                /*{
                  label: '客户手机号',
                  component: 'el-input',
                  field: 'c__customerContactNo',
                  span:12

                },*/
                {
                  label: '渠道商',
                  component: 'el-select',
                  field: 'd__dealerId',
                  options:[]

                },
                {
                  label: '申请日期',
                  component: 'date-range-picker',
                  field: 'fi__transactionDate',
                  op: ['gteq', 'lteq'],
                  span:12
                },
                {
                  label: '状态',
                  component: 'el-select',
                  field: 'fi__transactionStatus',
                  options: [
                    {
                      label: '全部',
                      value: ''
                    },
                    {
                      label: '待放款',
                      value: 'Ready'
                    },
                    {
                      label: '放款中',
                      value: 'Paying'
                    },
                    {
                      label: '还款中',
                      value: 'Processing'
                    },
                    {
                      label: '已还清',
                      value: 'Settled'
                    }
                  ],
                  op: 'eq',
                  span: 12
                },
                  {
                      label: '开始日期',
                      component: 'date-range-picker',
                      field: 'fi__startDate',
                      op: ['gteq', 'lteq'],
                      span:12
                  },
               /* {
                  label: '已逾期',
                  component: 'el-checkbox',
                  field: 'overdue',
                  span: 4
                },*/
                {
                  label: '还款方式',
                  component: 'el-select',
                  field: 'fi__repaymentFormula',
                  options: [
                    {
                      label: '全部',
                      value: ''
                    },
                    {
                      label: '等额本息',
                      value: 'DEBX'
                    },
                    {
                      label: '先息后本',
                      value: 'XXHB'
                    },

                  ],
                  op: 'eq',
                  span: 12
                },
                  {
                      label: '结束日期',
                      component: 'date-range-picker',
                      field: 'fi__endDate',
                      op: ['gteq', 'lteq'],
                      span:12
                  },

              ],
              onSubmit:()=>{
                this.page = 1
                this.getData()
              }
            }
          }
        },
        computed:{
          columns: function(){
            return [
              {
                type: 'index'
              },
              {
                label: '贷款编号',
                field: 'fi__transactionNo'
              },
              {
                label: '客户姓名',
                field: 'fi__customerName'
              },
              /*{
                label: '客户手机号',
                field: 'c__customerContactNo'
              },*/
              {
                label: '渠道商',
                field: 'd__dealerName'
              },
              {
                label: '还款方式',
                field: 'fi__repaymentFormula',
                formatter: function (r,c,v) {
                  return Status2CN(v)
                }
              },
              {
                label: '贷款金额',
                field: 'fi__totalAmount',
                formatter: function (r,c,v) {
                  return formatMoney(v)
                }
              },
              {
                label: '合同利率(%)',
                field: 'fi__interestRate',
                formatter: function (r,c,v) {
                  return v+'%'+'('+Status2CN(r.fi__interestType)+')'
                }
              },
              {
                label: '留存收益率(%)',
                field: 'dfi__interestRate',
                formatter: function (r,c,v) {
                  return v+'%'+'('+Status2CN(r.fi__interestType)+')'
                }
              },
              {
                label: '开始日期',
                field: 'fi__startDate',
                formatter: function (r,c,v) {
                  return moment(v).format('YYYY-MM-DD')
                }
              },
              {
                label: '结束日期',
                field: 'fi__endDate',
                formatter: function (r,c,v) {
                  return moment(v).format('YYYY-MM-DD')
                }
              },
              {
                label: '申请日期',
                field: 'fi__transactionDate',
                formatter: function (r,c,v) {
                  return moment(v).format('YYYY-MM-DD')
                }
              },
              {
                label: '状态',
                field: 'fi__transactionStatus',
                formatter: function (r,c,v) {
                  return Status2CN('Financing_'+v)
                  return v== 'Processing' && ( moment(r.fi__endDate).valueOf() < moment().valueOf() )? '已逾期' : Status2CN('Financing_'+ v)
                }
              },
              {
                label: '操作',
                opts:[
                  {
                    label: '查看',
                    class: 'el-icon-view',
                    clickHandler: (index, row) => {
                      this.$router.push({
                        name: 'CustomerFinancingDetailView',
                        query: {
                          'transactionId': row.fi__transactionId,
                        }
                      })
                    },
                  },
                  {
                    class: 'el-icon-printer',
                    name: '下载',
                      clickHandler: (index, row) => {
                          this.$router.push({
                              name: 'CustomerPrintDetailView',
                                  query: {
                                  'transactionId': row.fi__transactionId,
                              }
                          })
                      },
                  },
                  {
                    class: 'el-icon-download',
                    name: '打印还款计划表',
                    clickHandler: (index, row)=>{
                      this.exportPdf2(index, row)
                    }
                  }
                ]
              }
            ]
          },
          filterParams: {
            get: function() {
              return {
                pageSize: this.pageSize,
                pageOffset: (this.page - 1) * this.pageSize,
                   'xlist.search.fi.transactionStatus' : 'Processing,Ready,Settled',
                   'xlist.search.fi.transactionStatus.op' : 'in',
                    'xlist.sort.dataField': 'fi.startDate',
                    'xlist.sort.order': 'desc'
              }
            },
            set:function (newVal) {

            }
          }
        },
        watch: {
          filterParams: function () {
            this.getData()
          },
        },

        mounted() {
          this.getData()
          this.getDealerList()
        },
        methods: {
          getData: function () {
            xhr.getFinancingFangList(
              Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
              res => {
                try {
                  this.tableData = res.data
                } catch (e) {

                }
              })
          },
          getDealerList: function () {
            xhr.getDealerList(
              Object.assign({pageSize:0}, {},{}),
              res=> {
                try {
                  this.filters.columns[2].options = res.data.data.map(item=>{
                    return {
                      label: item.d__dealerName,
                      value:item.d__dealerId,
                    }
                  })
                }catch(e){

                }
              })

          },
          exportPdf: function (index, row) {
            try {
              window.open('/ix/fang/financing/LoanContract.jasper?transactionId='+row.fi__transactionId)
            }
            catch (e) {

            }
          },
          exportPdf2: function (index, row) {
            try {
              window.open('/ix/fang/financing/RepaymentPlan.jasper?transactionId='+row.fi__transactionId)
            }
            catch (e) {

            }
          },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerFinancingList.vue